<template>
  <div v-shortkey="['ctrl', 'space']" @shortkey="toggle()">
    
    <!--
    <v-bottom-sheet 
    v-model="searchScreen"
    fullscreen>
    -->

    <v-navigation-drawer
    v-model="searchScreen"
    fixed
    width="500px"
    class="foreground"
    style="z-index: 10;"
    temporary
    >

      <v-sheet class="foreground" height="100%">
        <v-layout align-center class="pa-2">

          <v-text-field
          v-model="searchScreenSearch"
          placeholder="Search..."
          hide-details
          class="crx-box-input"
          clearable
          ref="searchField"
          color="text"
          solo
          @keydown.down.prevent="focusBelow()"
          @keydown.up.prevent="focusAbove()"
          @keydown.enter.prevent="onEnter()">
          </v-text-field>

          <v-btn
            icon
            @click="searchScreen = !searchScreen"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-layout>

        <!-- MAIN -->
        <div>

          <div 
          v-if="sortedItems.length === 0"
          key="a"
          class="pa-4">
            No results found
          </div>

          <div v-else>
            <list-row
            v-for="(item, i) in sortedItems" 
            :key="i"
            :item="item"
            :active="currentIndex === i"
            :searchText="searchScreenSearch"
            @onClick="onClick">
            </list-row>
          </div>
          

          <!-- PRIORITY -->
          <v-layout justify-center class="pa-4">
            PRIORITY
            <v-badge
              color="red"
              right
              top
              overlap
              >
              <template v-slot:badge>
                1
              </template>
              <v-icon color="text" class="ml-4">mdi-bell-outline</v-icon>
            </v-badge>
          </v-layout>
          <div class="pa-4">
            Deliveries (best version of table so far)
            <br />
            Spacing - things look cluttered in night mode
          </div>

          <v-card>
            <v-img src="https://cdn.pixabay.com/photo/2017/04/08/22/26/meditation-2214532_1280.jpg">

            </v-img>
          </v-card>

        </div>

      </v-sheet>

    </v-navigation-drawer>
    <!-- </v-bottom-sheet> -->
    </div>
</template>

<script>
import ListRow from './search-console-row'

export default {
  components: {
    ListRow
  },
  data () {
    return {
      searchScreen: false,
      searchScreenSearch: '',
      options: [
        {
          name: 'Toggle dark mode',
          func: () => {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark
          }
        },
        {
          name: 'Toggle debug mode',
          func: () => {
            this.$store.commit('settings/SET_DEBUG_MODE', !this.$store.state.settings.debugMode)
          }
        },
        {
          name: 'Set Access Control 0',
          func: () => {
            this.$store.commit('auth/setAccessControl', [0])
            
          }
        },
        {
          name: 'Set Access Control 1',
          func: () => {
            this.$store.commit('auth/setAccessControl', [1])
            
          }
        },
        {
          name: 'Inventory',
          uri: '/inventory/inventory-definitions'
        },
        {
          name: 'Deliveries *',
          uri: '/deliveries'
        },
        {
          name: 'Themes',
          uri: '/inventory/inventory-definitions'
        },
        {
          name: 'Settings',
          uri: '/settings'
        },
        {
          name: 'Dashboard',
          uri: '/'
        },
      ],
      currentIndex: 1
    }
  },
  computed: {
    filteredItems () {
      return this.filter(this.options)
    },
    sortedItems () {
      return this.sort(0, true, this.filteredItems)
    }
  },
  watch: {
    sortedItems (nv) {
      if (nv.length >= this.currentIndex) {
        this.currentIndex = 0
      }
    }
  },
  methods: {
    focusBelow () {
      if (this.currentIndex < this.sortedItems.length - 1) {
        this.currentIndex ++
      }
    },
    focusAbove () {
      if (this.currentIndex > 0) {
        this.currentIndex--
      }
    },
    onClick (item) {
      if (this.searchScreen) { // only allow changing pages if nav drawer is open
        if (item.func) {
          item.func()
          this.searchScreen = false
        } else {
          this.$router.push(item.uri)
          this.searchScreen = false
        }
      }
    },
    onEnter () {
      var match = this.sortedItems[this.currentIndex]
      if (match) {
        this.onClick(match)
      }
    },
    toggle () {
      this.searchScreen = !this.searchScreen
      if (this.searchScreen) {
        setTimeout(() => {
          try {
            this.currentIndex = 0
            this.searchScreenSearch = ''
            this.$refs.searchField.focus()
          } catch (error) {
            console.log(error)
          }
        }, 50)
      } else {
        this.$refs.searchField.blur()
      }
    },
    trigger () {
      // console.log('i heard you')
    },
    filter (items) {
      if ((this.searchScreenSearch || '').length > 0) {
        var keywords = (this.searchScreenSearch || '').toLowerCase().split(' ')
        items = items.filter(item => {
          return keywords.every(keyword => {
            return (item.name.toLowerCase()).indexOf(keyword) > -1
          })
        })
      }
      return items
    },
    sort (headerIndex, sortAscending, items) {
      if (headerIndex === 0) { // default
        return items.sort((a, b) => {
          return sortAscending ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
        })
      } else if (headerIndex === 1) { // Items
        /* return items.sort((a, b) => {
          var itemCountA = this.$store.getters['db/deliveryItems/getDeliveryItems'](a.id).length
          var itemCountB = this.$store.getters['db/deliveryItems/getDeliveryItems'](b.id).length
          return sortAscending ? itemCountA - itemCountB : itemCountB - itemCountA
        }) */
      }
    }
  }
}
</script>

